/**
 * Returns an ISO timestamp that is strictly newer than every valid predecessor.
 *
 * Case and configuration ordering is shared with iOS, so a browser whose clock
 * moved backwards must never make an edit look older than the value it replaced.
 */
export function nextIsoTimestamp(
  now = new Date(),
  ...predecessors: Array<string | null | undefined>
): string {
  const nowMilliseconds = Number.isNaN(now.getTime()) ? Date.now() : now.getTime();
  const latestPredecessor = predecessors.reduce((latest, value) => {
    if (!value) return latest;
    const milliseconds = Date.parse(value);
    return Number.isNaN(milliseconds) ? latest : Math.max(latest, milliseconds);
  }, Number.NEGATIVE_INFINITY);

  return new Date(Math.max(nowMilliseconds, latestPredecessor + 1)).toISOString();
}
